export default "__VITE_ASSET__Bnkio93s__"